<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  created () {
    this.initAxiosConfig()
    if (this.checkToken()) {
      this.setUserName({
        userName: localStorage.getItem('userName')
      })
    } else {
      this.$router.push('/login')
    }
  },

  methods: {
    ...mapMutations([
      'setUserName'
    ]),

    initAxiosConfig () {
      axios.defaults.baseURL = '/api/v1'
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
      axios.interceptors.request.use(config => {
        const freeApi = ['/login']
        if (freeApi.indexOf(config.url) === -1 && !this.checkToken()) {
          return Promise.reject(new Error('登录信息失效'))
        }
        return config
      })

      axios.interceptors.response.use(result => {
        return {
          data: result.data.data,
          code: result.data.errno,
          message: result.data.errmsg
        }
      }, result => {
        let errorMessage
        if (result.response) {
          errorMessage = result.response.data
          if (result.response.status === 401) {
            errorMessage = '登录信息失效'
            this.$router.push('/login')
          } else if (result.response.status === 400) {
            errorMessage = result.response.data.errmsg
          } else if (result.response.status === 500) {
            errorMessage = `服务器内部错误: ${result.response.data.errmsg}`
          }
        } else {
          errorMessage = result.message
          this.$router.push('/login')
        }
        this.$Message.error(errorMessage)
        return Promise.reject(new Error(errorMessage))
      })
    }
  }
}
</script>
